<template>
  <div :id="id" :class="['checkbox-choice', active ? 'active': '']" @click="check"></div>
</template>

<script>
export default {
  props: [
    'id',
    'active'
  ],
  methods: {
    check () {
      this.$emit('check', !this.active)
    }
  }
}
</script>

<style lang="scss">
@import '../styles/mixins';
@import '../styles/variables';
</style>



// WEBPACK FOOTER //
// src/globals/checkbox.vue